(() => {
  if (!document.body.classList.contains('obp-b2b-portal-page')) return;

  const preview = new URLSearchParams(window.location.search).get('obp_b2b_preview') === '1';
  if (preview) {
    document.body.classList.add('obp-b2b-preview');
    const orderHeading = document.querySelector('.obp-b2b-order-shell__heading');
    if (orderHeading) {
      const eyebrow = orderHeading.querySelector('small');
      const title = orderHeading.querySelector('h2');
      const copy = orderHeading.querySelector('p');
      if (eyebrow) eyebrow.textContent = 'Händlerbestellung';
      if (title) title.textContent = 'Sortiment & Bestellung';
      if (copy) copy.textContent = 'Kein Mindestbestellwert. Der Versand für Fachhandelspartner ist europaweit kostenfrei.';
    }
  }

  const normalizePortalContacts = () => {
    const salesMaterialsLink = Array.from(document.querySelectorAll('.obp-b2b-portal__quick-card'))
      .find((link) => link.textContent.includes('Verkaufsunterlagen'));

    if (salesMaterialsLink) {
      salesMaterialsLink.href = 'mailto:b2bsales@onebuttonphone.de?subject=Verkaufsunterlagen%20f%C3%BCr%20den%20Fachhandel';
    }
  };

  normalizePortalContacts();

  const setupPortalNavigation = () => {
    const navigation = document.querySelector('.obp-b2b-portal__nav');
    if (!navigation) return;

    const spacer = document.createElement('div');
    spacer.className = 'obp-b2b-portal__nav-spacer';
    spacer.setAttribute('aria-hidden', 'true');
    navigation.parentNode.insertBefore(spacer, navigation);

    let navigationTop = 0;
    let navigationHeight = 0;
    let scrollTicking = false;
    let resizeTicking = false;

    const fixedOffset = () => window.matchMedia('(max-width: 700px)').matches ? 8 : 12;

    const updateFixedState = () => {
      const fixed = window.scrollY >= navigationTop - fixedOffset();
      navigation.classList.toggle('is-fixed', fixed);
      spacer.style.height = fixed ? `${navigationHeight}px` : '0px';
      scrollTicking = false;
    };

    const measureNavigation = () => {
      navigation.classList.remove('is-fixed');
      spacer.style.height = '0px';

      const styles = window.getComputedStyle(navigation);
      const marginTop = Number.parseFloat(styles.marginTop) || 0;
      navigationTop = navigation.getBoundingClientRect().top + window.scrollY;
      navigationHeight = navigation.offsetHeight + marginTop;

      updateFixedState();
      resizeTicking = false;
    };

    const requestScrollUpdate = () => {
      if (scrollTicking) return;
      scrollTicking = true;
      window.requestAnimationFrame(updateFixedState);
    };

    const requestMeasurement = () => {
      if (resizeTicking) return;
      resizeTicking = true;
      window.requestAnimationFrame(measureNavigation);
    };

    window.addEventListener('scroll', requestScrollUpdate, { passive: true });
    window.addEventListener('resize', requestMeasurement, { passive: true });
    window.addEventListener('pageshow', requestMeasurement);
    window.requestAnimationFrame(measureNavigation);

    const links = Array.from(navigation.querySelectorAll('a[href^="#"]'));
    const sections = links
      .map((link) => document.querySelector(link.getAttribute('href')))
      .filter(Boolean);

    const setActiveLink = (id) => {
      links.forEach((link) => {
        const active = link.getAttribute('href') === `#${id}`;
        link.classList.toggle('is-active', active);
        if (active) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    };

    if (!('IntersectionObserver' in window) || !sections.length) return;

    const observer = new IntersectionObserver((entries) => {
      const visible = entries
        .filter((entry) => entry.isIntersecting)
        .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
      if (visible) setActiveLink(visible.target.id);
    }, { rootMargin: '-18% 0px -67% 0px', threshold: [0, .1, .35] });

    sections.forEach((section) => observer.observe(section));
  };

  const setupOrderArchive = () => {
    const cards = Array.from(document.querySelectorAll('[data-obp-order-card]'))
      .sort((left, right) => Number(right.dataset.orderDate || 0) - Number(left.dataset.orderDate || 0));
    const list = document.querySelector('[data-obp-order-list]');
    const search = document.querySelector('[data-obp-order-search]');
    const filter = document.querySelector('[data-obp-order-filter]');
    const count = document.querySelector('[data-obp-order-count]');
    const toggle = document.querySelector('[data-obp-order-toggle]');
    const noResults = document.querySelector('[data-obp-order-no-results]');
    if (!cards.length || !search || !filter || !count || !toggle || !noResults) return;
    if (list) cards.forEach((card) => list.appendChild(card));
    const noResultsTitle = noResults.querySelector('strong');
    const noResultsCopy = noResults.querySelector('p');

    const initialLimit = 3;
    let expanded = false;

    const normalize = (value) => String(value || '')
      .toLocaleLowerCase('de-DE')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();

    const matchesStatus = (card, selectedStatus) => {
      const cancelled = card.dataset.orderCancelled === 'true';
      const financial = card.dataset.orderFinancial || '';
      const fulfillment = card.dataset.orderFulfillment || '';
      const paymentClosed = ['paid', 'refunded', 'voided', 'not_required'].includes(financial);
      const shippingClosed = fulfillment === 'fulfilled' || ['refunded', 'voided'].includes(financial);
      const invoiceOpen = card.dataset.orderInvoiceOpen === 'true' && !paymentClosed;
      if (selectedStatus === 'cancelled') return cancelled;
      if (cancelled) return false;
      if (selectedStatus === 'all') return true;
      if (selectedStatus === 'current') return invoiceOpen || !paymentClosed || !shippingClosed;
      if (selectedStatus === 'completed') return paymentClosed && shippingClosed && !invoiceOpen;
      if (selectedStatus === 'invoice') return invoiceOpen;
      if (selectedStatus === 'documents') return card.dataset.orderDocuments === 'true';
      if (selectedStatus === 'paid') return financial === 'paid';
      if (selectedStatus === 'fulfilled') return fulfillment === 'fulfilled';
      if (selectedStatus === 'open') return invoiceOpen || !paymentClosed || !shippingClosed;
      return true;
    };

    const applyFilters = () => {
      const query = normalize(search.value);
      const selectedStatus = filter.value;
      const filtering = query !== '' || selectedStatus !== 'current';
      const matches = cards.filter((card) => {
        const haystack = normalize(card.dataset.orderSearch);
        return (!query || haystack.includes(query)) && matchesStatus(card, selectedStatus);
      });

      cards.forEach((card) => {
        const matchIndex = matches.indexOf(card);
        const show = matchIndex !== -1 && (filtering || expanded || matchIndex < initialLimit);
        card.hidden = !show;
      });

      count.textContent = selectedStatus === 'current'
        ? (matches.length === 1 ? '1 aktueller Vorgang' : `${matches.length} aktuelle Vorgänge`)
        : selectedStatus === 'completed'
          ? (matches.length === 1 ? '1 abgeschlossene Bestellung' : `${matches.length} abgeschlossene Bestellungen`)
          : (matches.length === 1 ? '1 passende Bestellung' : `${matches.length} passende Bestellungen`);
      noResults.hidden = matches.length !== 0;
      if (noResultsTitle && noResultsCopy) {
        const currentViewIsEmpty = selectedStatus === 'current' && query === '';
        noResultsTitle.textContent = currentViewIsEmpty
          ? 'Derzeit ist kein offener Vorgang vorhanden.'
          : 'Keine passende Bestellung gefunden.';
        noResultsCopy.textContent = currentViewIsEmpty
          ? 'Vergangene Bestellungen und Belege finden Sie über den Statusfilter.'
          : 'Ändern Sie den Suchbegriff oder wählen Sie einen anderen Status.';
      }
      toggle.hidden = filtering || matches.length <= initialLimit;
      toggle.textContent = expanded
        ? 'Aktuelle Vorgänge kompakt anzeigen'
        : `Alle ${matches.length} aktuellen Vorgänge anzeigen`;
      toggle.setAttribute('aria-expanded', String(expanded));
    };

    search.addEventListener('input', applyFilters);
    filter.addEventListener('change', applyFilters);
    toggle.addEventListener('click', () => {
      expanded = !expanded;
      applyFilters();
      if (!expanded) document.querySelector('#obp-b2b-orders')?.scrollIntoView({ block: 'start' });
    });

    document.querySelectorAll('[data-obp-order-view]').forEach((link) => {
      link.addEventListener('click', () => {
        const requestedView = link.dataset.obpOrderView || 'all';
        const requestedQuery = link.dataset.obpOrderQuery || '';
        filter.value = Array.from(filter.options).some((option) => option.value === requestedView)
          ? requestedView
          : 'all';
        search.value = requestedQuery;
        expanded = true;
        applyFilters();
      });
    });

    applyFilters();
  };

  setupPortalNavigation();
  setupOrderArchive();

  const improveLoggedOutCopy = (root) => {
    if (document.body.classList.contains('obp-b2b-customer')) return;

    const headings = Array.from(root.querySelectorAll('h2'));
    const loginHeading = headings.find((element) => element.textContent.trim() === 'Kein Kunde gefunden');
    if (loginHeading) loginHeading.textContent = 'Bitte melden Sie sich an.';

    const paragraphs = Array.from(root.querySelectorAll('p'));
    const loginCopy = paragraphs.find((element) => element.textContent.includes('Du musst dich einloggen'));
    if (loginCopy) loginCopy.textContent = 'Dieser Bereich ist unseren freigeschalteten Fachhandelspartnern vorbehalten.';

    const buttons = Array.from(root.querySelectorAll('button'));
    const loginButton = buttons.find((element) => element.textContent.trim() === 'Einloggen');
    if (loginButton) loginButton.textContent = 'Zum Händler-Login';
  };

  const compactCollectionIntro = (root) => {
    const candidates = Array.from(root.querySelectorAll('.max-w-screen-xl.bg-gray-100'));
    const intro = candidates.find((element) =>
      element.textContent.includes('Willkommen im One Button Phone Händlerportal')
    );

    if (!intro || intro.dataset.obpCompactIntro === 'true') return;

    intro.dataset.obpCompactIntro = 'true';
    intro.classList.add('obp-b2b-shop-note-shell');
    intro.innerHTML = `
      <section class="obp-b2b-shop-note" aria-labelledby="obp-b2b-shop-note-title">
        <div class="obp-b2b-shop-note__intro">
          <small>Gut zu wissen</small>
          <strong id="obp-b2b-shop-note-title">Einfach bestellen. Alles Wichtige auf einen Blick.</strong>
        </div>
        <div class="obp-b2b-shop-note__grid">
          <div><span>01</span><strong>Verfügbarkeit</strong><small>Lieferstatus direkt am Artikel.</small></div>
          <div><span>02</span><strong>Ihre Referenz</strong><small>Bestell- oder Kommissionsnummer im Checkout.</small></div>
          <div><span>03</span><strong>Versand</strong><small>Europaweit kostenfrei, in der Regel mit DHL.</small></div>
          <div><span>04</span><strong>Belege</strong><small>Per E-Mail und in Ihrer Bestellübersicht.</small></div>
        </div>
        <p>Kleinteile können als Deutsche-Post-Brief ohne Sendungsverfolgung versendet werden.</p>
      </section>
    `;
  };

  const syncBuddyPreorderState = (root) => {
    const isB2BOrderFlow = /^\/apps\/b2b\/(collections|cart|checkout)(?:\/|$)/.test(window.location.pathname);
    const isOrderStep = /^\/apps\/b2b\/(cart|checkout)(?:\/|$)/.test(window.location.pathname);
    const buddyCells = isB2BOrderFlow
      ? Array.from(root.querySelectorAll('td[role="cell"]')).filter((cell) => {
        const ownText = Array.from(cell.childNodes)
          .filter((node) => node.nodeType === Node.TEXT_NODE)
          .map((node) => node.textContent || '')
          .join(' ');
        return /One Button Phone Buddy/i.test(ownText);
      })
      : [];

    buddyCells.forEach((cell) => {
      if (cell.querySelector('[data-obp-buddy-preorder-label]')) return;

      const label = document.createElement('span');
      label.className = 'obp-b2b-buddy-preorder-label';
      label.dataset.obpBuddyPreorderLabel = 'true';
      label.setAttribute('aria-label', 'Vorbestellung, Auslieferung ab 12. Oktober 2026');
      label.innerHTML = `
        <strong>Vorbestellung</strong>
        <small>Auslieferung ab 12. Oktober 2026</small>
      `;

      const lineBreak = cell.querySelector(':scope > br');
      if (lineBreak) cell.insertBefore(label, lineBreak);
      else cell.appendChild(label);
    });

    const hasBuddy = buddyCells.length > 0;
    let notice = root.querySelector('#obp-b2b-buddy-preorder-notice');

    if (!isOrderStep || !hasBuddy) {
      if (notice) notice.remove();
      return;
    }

    if (!notice) {
      notice = document.createElement('section');
      notice.id = 'obp-b2b-buddy-preorder-notice';
      notice.setAttribute('role', 'status');
      notice.setAttribute('aria-label', 'Lieferhinweis zum One Button Phone Buddy');
      notice.innerHTML = `
        <span class="obp-b2b-buddy-preorder-notice__icon" aria-hidden="true">!</span>
        <span>
          <strong>Der One Button Phone Buddy wird vorbestellt</strong>
          <small>Auslieferung ab 12. Oktober 2026 in der Reihenfolge der Bestellungen. Sofort verfügbare Artikel können separat und für Sie weiterhin versandkostenfrei versendet werden.</small>
        </span>
      `;

      const target = root.querySelector('.max-w-screen-xl') || root.querySelector('main') || root.firstElementChild;
      if (target) target.prepend(notice);
    }
  };

  const customizeCheckout = (root) => {
    if (!/^\/apps\/b2b\/checkout(?:\/|$)/.test(window.location.pathname)) return;

    const logout = Array.from(root.querySelectorAll('a, button'))
      .find((element) => element.textContent.trim() === 'Logout');
    if (logout) logout.textContent = 'Abmelden';

    const billingCheckbox = root.querySelector('input[name="useShippingAddressForBilling"]');
    const billingLabel = billingCheckbox
      ? root.querySelector(`label[for="${billingCheckbox.id}"]`)
      : null;
    if (billingLabel && billingLabel.textContent.trim() !== 'Lieferadresse auch als Rechnungsadresse verwenden') {
      billingLabel.textContent = 'Lieferadresse auch als Rechnungsadresse verwenden';
    }

    const shippingRate = root.querySelector('input[name="shippingRate"]');
    const shippingCard = shippingRate?.closest('.border');
    const shippingTitle = shippingCard?.querySelector('p.text-base');
    if (shippingTitle && shippingTitle.textContent.trim() !== 'Kostenfreier Fachhandelsversand') {
      shippingTitle.textContent = 'Kostenfreier Fachhandelsversand';
    }
    if (shippingCard) shippingCard.classList.add('obp-b2b-checkout-shipping');

    const prepareField = ({ name, title, placeholder, help, helpId }) => {
      const field = root.querySelector(`[name="${name}"]`);
      const group = field?.closest('.space-y-3');
      if (!field || !group) return;

      group.classList.add('obp-b2b-checkout-field');
      const heading = group.querySelector(':scope > h2');
      if (heading && heading.textContent.trim() !== title) heading.textContent = title;
      if (field.getAttribute('placeholder') !== placeholder) field.setAttribute('placeholder', placeholder);
      field.setAttribute('aria-describedby', helpId);

      let helper = group.querySelector(`#${helpId}`);
      if (!helper) {
        helper = document.createElement('p');
        helper.id = helpId;
        helper.className = 'obp-b2b-checkout-field__help';
        helper.textContent = help;
        field.insertAdjacentElement('afterend', helper);
      }
    };

    prepareField({
      name: 'poNumber',
      title: 'Bestell- oder Kommissionsnummer (optional)',
      placeholder: 'z. B. BEST-2026-123 oder Filiale Würzburg',
      help: 'Ihre interne Referenz wird mit der Bestellung übermittelt und erleichtert die eindeutige Zuordnung.',
      helpId: 'obp-b2b-po-number-help'
    });

    prepareField({
      name: 'orderNote',
      title: 'Hinweise zur Bestellung (optional)',
      placeholder: 'z. B. Ansprechpartner, Anlieferhinweis oder gewünschte Zuordnung',
      help: 'Nutzen Sie dieses Feld für zusätzliche Informationen an unser B2B Sales Team.',
      helpId: 'obp-b2b-order-note-help'
    });
  };

  const styleShadowRoot = () => {
    const host = document.querySelector('#eg-b2b_app-proxy_container');
    const root = host && host.shadowRoot;
    if (!root || typeof root.nodeType !== 'number' || typeof root.querySelector !== 'function') return false;
    if (!root.querySelector('#obp-b2b-shadow-style')) {
      const style = document.createElement('style');
      style.id = 'obp-b2b-shadow-style';
      style.textContent = `
      :host { color: #252929; }
      h1.text-4xl { display: none !important; }
      .relative.z-20.w-full { margin: 0 !important; border-radius: 18px !important; background: transparent !important; }
      .max-w-screen-xl { max-width: 1180px !important; }
      .bg-gray-100 { background: #ffffff !important; border: 1px solid #d7e5e3 !important; border-radius: 18px !important; }
      button.bg-gray-800 { background: #ff6700 !important; border-radius: 10px !important; min-height: 50px !important; }
      button.bg-gray-800:hover { background: #e95e00 !important; }
      input, select, textarea { border-radius: 9px !important; }
      .obp-b2b-checkout-shipping {
        border-color: #c6dfdc !important;
        background: #f4faf9 !important;
      }
      .obp-b2b-checkout-shipping p.text-base {
        color: #174f4b !important;
        font-weight: 750 !important;
      }
      .obp-b2b-checkout-field {
        padding: 16px !important;
        border: 1px solid #d7e5e3 !important;
        border-radius: 13px !important;
        background: #fff !important;
      }
      .obp-b2b-checkout-field > h2 {
        margin: 0 !important;
        color: #174f4b !important;
        font-size: 15px !important;
        font-weight: 750 !important;
        line-height: 1.4 !important;
      }
      .obp-b2b-checkout-field input,
      .obp-b2b-checkout-field textarea {
        min-height: 46px !important;
        border-color: #cbdad8 !important;
        background: #fff !important;
      }
      .obp-b2b-checkout-field textarea { min-height: 92px !important; }
      .obp-b2b-checkout-field input::placeholder,
      .obp-b2b-checkout-field textarea::placeholder {
        color: #86928f !important;
        opacity: 1 !important;
      }
      .obp-b2b-checkout-field__help {
        margin: -3px 0 0 !important;
        color: #657370 !important;
        font-size: 12px !important;
        line-height: 1.45 !important;
      }
      #obp-b2b-buddy-preorder-notice {
        display: flex;
        gap: 14px;
        align-items: flex-start;
        margin: 0 auto 20px;
        padding: 17px 18px;
        border: 1px solid #f0c6aa;
        border-radius: 14px;
        background: #fff7ef;
        color: #684226;
        box-shadow: 0 12px 30px -26px rgba(82, 48, 23, .65);
      }
      .obp-b2b-buddy-preorder-notice__icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 30px;
        height: 30px;
        flex: 0 0 30px;
        border-radius: 9px;
        background: #ff6700;
        color: #fff;
        font-size: 17px;
        font-weight: 800;
      }
      #obp-b2b-buddy-preorder-notice strong,
      #obp-b2b-buddy-preorder-notice small { display: block; }
      #obp-b2b-buddy-preorder-notice strong {
        color: #3f2a1b;
        font-size: 15px;
        line-height: 1.35;
      }
      #obp-b2b-buddy-preorder-notice small {
        margin-top: 4px;
        color: #765740;
        font-size: 13px;
        line-height: 1.5;
      }
      .obp-b2b-buddy-preorder-label {
        display: inline-flex;
        flex-direction: column;
        align-items: flex-start;
        max-width: 230px;
        margin: 7px 0 0;
        padding: 6px 9px;
        border: 1px solid #f0c6aa;
        border-radius: 9px;
        background: #fff7ef;
        color: #684226;
        vertical-align: middle;
      }
      .obp-b2b-buddy-preorder-label strong,
      .obp-b2b-buddy-preorder-label small { display: block; }
      .obp-b2b-buddy-preorder-label strong {
        color: #d45100;
        font-size: 11px;
        font-weight: 800;
        line-height: 1.25;
        letter-spacing: .04em;
        text-transform: uppercase;
      }
      .obp-b2b-buddy-preorder-label small {
        margin-top: 2px;
        color: #765740;
        font-size: 11px;
        line-height: 1.35;
      }
      .obp-b2b-shop-note-shell {
        display: block !important;
        padding: 0 !important;
        border: 0 !important;
        background: transparent !important;
      }
      .obp-b2b-shop-note {
        padding: 22px;
        border: 1px solid #d7e5e3;
        border-radius: 18px;
        background: linear-gradient(135deg, #f4faf9 0%, #ffffff 72%);
        color: #252929;
      }
      .obp-b2b-shop-note__intro small,
      .obp-b2b-shop-note__intro strong {
        display: block;
      }
      .obp-b2b-shop-note__intro small {
        color: #3d9f97;
        font-size: 11px;
        font-weight: 800;
        letter-spacing: .12em;
        text-transform: uppercase;
      }
      .obp-b2b-shop-note__intro strong {
        margin-top: 6px;
        color: #134f4a;
        font-size: 20px;
        line-height: 1.25;
      }
      .obp-b2b-shop-note__grid {
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: 10px;
        margin-top: 18px;
      }
      .obp-b2b-shop-note__grid > div {
        min-width: 0;
        padding: 14px;
        border: 1px solid #dfeae8;
        border-radius: 13px;
        background: rgba(255, 255, 255, .88);
      }
      .obp-b2b-shop-note__grid span,
      .obp-b2b-shop-note__grid strong,
      .obp-b2b-shop-note__grid small {
        display: block;
      }
      .obp-b2b-shop-note__grid span {
        color: #3d9f97;
        font-size: 10px;
        font-weight: 800;
        letter-spacing: .08em;
      }
      .obp-b2b-shop-note__grid strong {
        margin-top: 7px;
        color: #174f4b;
        font-size: 13px;
        line-height: 1.35;
      }
      .obp-b2b-shop-note__grid small {
        margin-top: 4px;
        color: #657370;
        font-size: 12px;
        line-height: 1.4;
      }
      .obp-b2b-shop-note > p {
        margin: 13px 0 0;
        color: #657370;
        font-size: 11px;
        line-height: 1.45;
      }
      @media (max-width: 820px) {
        .obp-b2b-shop-note__grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
      }
      @media (max-width: 520px) {
        .obp-b2b-shop-note { padding: 18px; }
        .obp-b2b-shop-note__grid { grid-template-columns: minmax(0, 1fr); }
      }
    `;
      root.appendChild(style);
    }

    improveLoggedOutCopy(root);
    compactCollectionIntro(root);
    syncBuddyPreorderState(root);
    customizeCheckout(root);

    if (!root.__obpB2BObserver) {
      const shadowObserver = new MutationObserver(() => {
        improveLoggedOutCopy(root);
        compactCollectionIntro(root);
        syncBuddyPreorderState(root);
        customizeCheckout(root);
      });
      try {
        shadowObserver.observe(root, { childList: true, subtree: true });
        root.__obpB2BObserver = shadowObserver;
      } catch (_) {
        shadowObserver.disconnect();
        root.__obpB2BObserver = true;
      }
    }

    return true;
  };

  if (!styleShadowRoot()) {
    const observer = new MutationObserver(() => {
      if (styleShadowRoot()) observer.disconnect();
    });
    if (document.documentElement && typeof document.documentElement.nodeType === 'number') {
      try {
        observer.observe(document.documentElement, { childList: true, subtree: true });
      } catch (_) {
        observer.disconnect();
      }
    }
    window.setTimeout(() => observer.disconnect(), 12000);
  }
})();
